interface AgentAuthDataSource {
  sourceApp?: string;
  sourceOrigin?: string;
}

/**
 * Resolves sourceApp/sourceOrigin for impersonation tracing, falling back to
 * this app's own identity when the session isn't impersonating anyone.
 */
export function getAgentSourceFields(
  user?: { agentAuthData?: AgentAuthDataSource } | null
) {
  return {
    sourceApp: user?.agentAuthData?.sourceApp ?? 'meraki-frontend',
    sourceOrigin:
      user?.agentAuthData?.sourceOrigin ?? window.location.origin + '/',
  };
}
